const categoriesData = [
  {
    id: '1',
    img: {
      className: 'category_img',
      src: 'icons/vehicle.webp',
      alt: 'Vehicles and car parts',
    },
    link: 'Vehicles_and_car_parts',
    name: 'Vehicles and car parts',
    subcategories: [
      {
        id: '1-1',
        name: 'Passenger Cars',
        img: {
          className: 'subcategory_img',
          src: 'icons/sub/car.png',
          alt: 'Passenger Cars',
        },
        productsLink: 'products/passenger_cars',
        options: {
          option1: {
            name: 'Make',
            values: [
              'Acura',
              'Alfa Romeo',
              'Aston Martin',
              'Audi',
              'BMW',
              'Bentley',
              'Buick',
              'Bugatti',
              'Cadillac',
              'Chevrolet',
              'Chrysler',
              'Citroën',
              'Daihatsu',
              'Dodge',
              'DS',
              'Ferrari',
              'Fiat',
              'Fisker',
              'Ford',
              'Genesis',
              'GMC',
              'Hummer',
              'Honda',
              'Hyundai',
              'Infiniti',
              'Jaguar',
              'Jeep',
              'Kia',
              'Lamborghini',
              'Land Rover',
              'Lexus',
              'Lincoln',
              'Lotus',
              'Mazda',
              'Mercedes-Benz',
              'Maserati',
              'Mini',
              'Mitsubishi',
              'Nissan',
              'Opel',
              'Peugeot',
              'Polestar',
              'Pontiac',
              'Porsche',
              'Renault',
              'Rolls-Royce',
              'Rover',
              'Saab',
              'Seat',
              'Skoda',
              'Smart',
              'SsangYong',
              'Spyker',
              'Subaru',
              'Tesla',
              'Toyota',
              'Tucker',
              'Volkswagen',
              'Volvo',
              'Wiesmann',
              'Other',
            ],
          },
          option2: {
            name: 'Year',
            values: [
              '2025',
              '2024',
              '2023',
              '2022',
              '2021',
              '2020',
              '2019',
              '2018',
              '2017',
              '2016',
              '2015',
              '2014',
              '2013',
              '2012',
              '2011',
              '2010',
              '2009',
              '2008',
              '2007',
              '2006',
              '2005',
              '2004',
              '2003',
              '2002',
              '2001',
              '2000',
              '1999',
              '1998',
              '1997',
              '1996',
              '1995',
              '1994',
              '1993',
              '1992',
              '1991',
              '1990',
              '1989',
              '1988',
              '1987',
              '1986',
              '1985',
              '1984',
              '1983',
              '1982',
              '1981',
              '1980',
              '1979',
              '1978',
              '1977',
              '1976',
              '1975',
              '1974',
              '1973',
              '1972',
              '1971',
              '1970',
              '1969',
              '1968',
              '1967',
              '1966',
              '1965',
              '1964',
              '1963',
              '1962',
              '1961',
              '1960',
            ],
          },
          option3: {
            name: 'Body',
            values: [
              'Sedan',
              'SUV',
              'Hatchback',
              'Liftback',
              'Limousine',
              'Pickup',
              'Cabriolet',
              'Coupe',
              'Wagon',
              'Passenger',
              'Roadster',
              'Other',
            ],
          },
          option4: {
            name: 'Transmission',
            values: ['Automatic', 'Manual', 'Variator', 'Robotic'],
          },
          option5: {
            name: 'Drive',
            values: ['FWD', 'AWD', 'RWD', '4WD'],
          },
          option6: {
            name: 'Fuel Type',
            values: ['Gasoline', 'Diesel', 'Hybrid', 'Electric'],
          },
          option7: {
            name: 'Interior Color',
            values: ['Dark', 'Light', 'Combined Colors'],
          },
          option8: {
            name: 'Mileage',
            values: [
              '0 - 5000 km',
              '5000 - 20000 km',
              '20000 - 50000 km',
              '50000 - 100000 km',
              '100000 - 150000 km',
              '150000 km and more',
            ],
          },
        },
      },
      {
        id: '1-2',
        name: 'Trucks and Buses',
        img: {
          className: 'subcategory_img',
          src: 'icons/sub/truck.png',
          alt: 'Trucks and Buses',
        },
        productsLink: 'products/trucks_buses',
        options: {
          option1: {
            name: 'Make',
            values: [
              'Chevrolet',
              'Dodge',
              'Ford',
              'Freightliner',
              'GMC',
              'Hyundai',
              'International',
              'Isuzu',
              'Iveco',
              'Kenworth',
              'Mack',
              'Peterbit',
              'Volvo',
              'Other',
            ],
          },
          option2: {
            name: 'Year',
            values: [
              '2025',
              '2024',
              '2023',
              '2022',
              '2021',
              '2020',
              '2019',
              '2018',
              '2017',
              '2016',
              '2015',
              '2014',
              '2013',
              '2012',
              '2011',
              '2010',
              '2009',
              '2008',
              '2007',
              '2006',
              '2005',
              '2004',
              '2003',
              '2002',
              '2001',
              '2000',
              '1999',
              '1998',
              '1997',
              '1996',
              '1995',
              '1994',
              '1993',
              '1992',
              '1991',
              '1990',
              '1989',
              '1988',
              '1987',
              '1986',
              '1985',
              '1984',
              '1983',
              '1982',
              '1981',
              '1980',
              '1979',
              '1978',
              '1977',
              '1976',
              '1975',
              '1974',
              '1973',
              '1972',
              '1971',
              '1970',
              '1969',
              '1968',
              '1967',
              '1966',
              '1965',
              '1964',
              '1963',
              '1962',
              '1961',
              '1960',
            ],
          },
          option3: {
            name: 'Type',
            values: [
              'Ballast tractor',
              'Bottler',
              'Box Trucks',
              'Bus',
              'Cube Vans',
              'Cutaway van chassis',
              'Delivery truck',
              'Dump truck',
              'Firetruck',
              'Flatbed truck',
              'Garbage truck',
              'Heavy hauler',
              'Log carrier',
              'Medium Duty Truck',
              'Medium Standard Truck',
              'Multi-Stop truck',
              'Platform truck',
              'Recreational Vehicle',
              'Refrigerator truck',
              'Stake bed truck',
              'Tank truck',
              'Tow truck',
              'Tractor unit',
            ],
          },
          option4: {
            name: 'Transmission',
            values: ['Automatic', 'Manual'],
          },
          option5: {
            name: 'Fuel type',
            values: ['Diesel', 'Gas'],
          },
          option6: {
            name: 'Mileage',
            values: [
              '0 - 5000 km',
              '5000 - 20000 km',
              '20000 - 50000 km',
              '50000 - 100000 km',
              '100000 - 150000 km',
              '150000 km and more',
            ],
          },
        },
      },
      {
        id: '1-3',
        name: 'Auto Parts',
        img: {
          className: 'subcategory_img',
          src: 'icons/sub/car-parts.png',
          alt: 'Auto Parts',
        },
        productsLink: 'products/auto_parts',
        options: {
          option1: {
            name: 'Type',
            values: [
              'Car parts',
              'Truck parts',
              'Agricultural machinery parts',
              'Special machinery parts',
              'Motorcycle parts',
              'Other',
            ],
          },
        },
      },
      {
        id: '1-4',
        name: 'Tires and Rims',
        img: {
          className: 'subcategory_img',
          src: 'icons/sub/rim.png',
          alt: 'Tires and Rims',
        },
        productsLink: 'products/tires_rims',
        options: {
          option1: {
            name: 'Type',
            values: [
              'Car tires',
              'Truck tires',
              'Motorcycle tires',
              'Rims',
              'Wheel caps',
              'Other',
            ],
          },
        },
      },
      {
        id: '1-5',
        name: 'Accessories and Automotive Chemicals',
        img: {
          className: 'subcategory_img',
          src: 'icons/sub/steering-wheel.png',
          alt: 'Accessories and Automotive Chemicals',
        },
        productsLink: 'products/accessories_chemicals',
        options: {
          option1: {
            name: 'Type',
            values: [
              'Additives',
              'Antifreeze',
              'Auto body and interior cosmetics',
              'Brake fluid',
              'Cleaners',
              'Distilled water',
              'Flushing oil',
              'Gear oil',
              'Glass-washing liquids',
              'Industrial oil',
              'Lubricants',
              'Materials for body repair',
              'Motor oil',
              'Sealants and adhesives',
            ],
          },
        },
      },
      {
        id: '1-6',
        name: 'Farm machinery',
        img: {
          className: 'subcategory_img',
          src: 'icons/sub/tractor.png',
          alt: 'Farm machinery',
        },
        productsLink: 'products/Farm_machinery',
        options: {
          option1: {
            name: 'Type',
            values: [
              'Backhoe',
              'Balers',
              'Belt conveyors',
              'Combine harvester',
              'Corn harvester',
              'Cultivator',
              'Cultipacker',
              'Harrow',
              'Harvester',
              'Implement carrying tractors',
              'Irrigation equipment',
              'Loaders',
              'Mowers',
              'Plough',
              'Ploughs',
              'Rotavator or Rotary tiller',
              'Seeders',
              'Sprayer',
              'Tractors',
              'Transplanters',
            ],
          },
        },
      },
      {
        id: '1-7',
        name: 'Trailers',
        img: {
          className: 'subcategory_img',
          src: 'icons/sub/trailer.png',
          alt: 'Trailers',
        },
        productsLink: 'products/trailers',
        options: {
          option1: {
            name: 'Type',
            values: [
              'Boat Trailers',
              'Camper Trailers',
              'Dump Trailers',
              'Enclosed Trailers',
              'Flatbed Trailers',
              'Horse Trailers',
              'Tilt Deck Trailers',
              'Toy Haulers',
              'Utility Trailers',
              'Other',
            ],
          },
        },
      },
      {
        id: '1-8',
        name: 'Watercraft',
        img: {
          className: 'subcategory_img',
          src: 'icons/sub/watercraft.png',
          alt: 'Watercraft',
        },
        productsLink: 'products/watercraft',
        options: {
          option1: {
            name: 'Type',
            values: [
              'Air boat',
              'Bass boat',
              'Bowrider',
              'Cabin boat',
              'Canoe',
              'Catamaran',
              'Center console boat',
              'Cruiser boat',
              'Deck boat',
              'Dingny boat',
              'Fishing boat',
              'High performance boat',
              'House boat',
              'Jet boat',
              'Jon boat',
              'Kayak',
              'Motor yacht boat',
              'Personal water boat',
              'Pontoon boat',
              'Runabout',
              'Sailing boat',
              'Ski boat',
              'Trawler boat',
              'Wake boat',
              'Windsurf',
              'Other',
            ],
          },
        },
      },
      {
        id: '1-9',
        name: 'Motorbikes / off-road vehicles',
        img: {
          className: 'subcategory_img',
          src: 'icons/sub/motocycle.png',
          alt: 'Motorbikes / off-road vehicles',
        },
        productsLink: 'products/motorbikes',
        options: {
          option1: {
            name: 'Type',
            values: [
              'Motorcycle',
              'Scooter / moped',
              'ATV',
              'Snowmobile',
              'Side-by-side/utv',
              'Golf cart',
              'Go-kart',
              'Dune buggy',
              'Other',
            ],
          },
        },
      },
      {
        id: '1-10',
        name: 'Garage Tools and Equipment',
        img: {
          className: 'subcategory_img',
          src: 'icons/sub/car-jack.png',
          alt: 'Garage Tools and Equipment',
        },
        productsLink: 'products/garage_tools',
      },
    ],
  },
  {
    id: '2',
    img: {
      className: 'category_img',
      src: 'icons/tools.webp',
      alt: 'Repair and construction',
    },
    name: 'Repair and construction',
    link: 'Repair_and_construction',
    subcategories: [
      {
        id: '2-1',
        name: 'Construction Tools and Equipment',
        img: {
          className: 'subcategory_img',
          src: 'icons/sub/construction_tools.png',
          alt: 'Construction Tools and Equipment',
        },
        productsLink: 'products/construction_tools',
      },
      {
        id: '2-2',
        name: 'Plumbing and Heating',
        img: {
          className: 'subcategory_img',
          src: 'icons/sub/plumbing_heating.png',
          alt: 'Plumbing and Heating',
        },
        productsLink: 'products/plumbing_heating',
      },
      {
        id: '2-3',
        name: 'Building Materials',
        img: {
          className: 'subcategory_img',
          src: 'icons/sub/building_materials.png',
          alt: 'Building Materials',
        },
        productsLink: 'products/building_materials',
      },
      {
        id: '2-4',
        name: 'Finishing Materials',
        img: {
          className: 'subcategory_img',
          src: 'icons/sub/finishing_materials.png',
          alt: 'Finishing Materials',
        },
        productsLink: 'products/finishing_materials',
      },
      {
        id: '2-5',
        name: 'Windows and Doors',
        img: {
          className: 'subcategory_img',
          src: 'icons/sub/windows_doors.png',
          alt: 'Windows and Doors',
        },
        productsLink: 'products/windows_doors',
      },
      {
        id: '2-6',
        name: 'Prefabricated Buildings',
        img: {
          className: 'subcategory_img',
          src: 'icons/sub/Prefabricated_buildings.png',
          alt: 'Prefabricated Buildings',
        },
        productsLink: 'products/prefabricated_buildings',
      },
      {
        id: '2-7',
        name: 'Gates and Fences',
        img: {
          className: 'subcategory_img',
          src: 'icons/sub/gates_fences.png',
          alt: 'Gates and Fences',
        },
        productsLink: 'products/gates_fences',
      },
      {
        id: '2-8',
        name: 'Electrical Supplies',
        img: {
          className: 'subcategory_img',
          src: 'icons/sub/electrical_supplies.png',
          alt: 'Electrical Supplies',
        },
        productsLink: 'products/electrical_supplies',
      },
      {
        id: '2-9',
        name: 'Miscellaneous for Repair and Construction',
        img: {
          className: 'subcategory_img',
          src: 'icons/sub/miscellaneous_repair.png',
          alt: 'Miscellaneous for Repair and Construction',
        },
        productsLink: 'products/miscellaneous_repair',
      },
    ],
  },
  {
    id: '3',
    img: {
      className: 'category_img',
      src: 'icons/hobbie.webp',
      alt: 'Hobbies, Sports, and Tourism',
    },
    link: 'Hobbies_sports_and_tourism',
    name: 'Hobbies, Sports, and Tourism',
    subcategories: [
      {
        id: '3-1',
        name: 'CDs, DVDs, Records',
        img: {
          className: 'subcategory_img',
          src: 'icons/sub/cds_dvds_records.png',
          alt: 'CDs, DVDs, Records',
        },
        productsLink: 'products/cds_dvds_records',
        options: {
          option1: {
            name: 'Media type',
            values: [
              'CD',
              'Vinyl',
              'Other audio',
              'Blu-ray',
              'DVD',
              'VHS',
              'Other video',
            ],
          },
        },
      },
      {
        id: '3-2',
        name: 'Antiques and Collections',
        img: {
          className: 'subcategory_img',
          src: 'icons/sub/collection.png',
          alt: 'Antiques and Collections',
        },
        productsLink: 'products/antiques_collections',
        options: {
          option1: {
            name: 'Type',
            values: [
              'Antiques',
              'Collections',
              'Paintings',
              'Objects of Art',
              'Other',
            ],
          },
        },
      },
      {
        id: '3-3',
        name: 'Tickets',
        img: {
          className: 'subcategory_img',
          src: 'icons/sub/tickets.png',
          alt: 'Tickets',
        },
        productsLink: 'products/tickets',
      },
      {
        id: '3-4',
        name: 'Books and Magazines',
        img: {
          className: 'subcategory_img',
          src: 'icons/sub/comic.png',
          alt: 'Books and Magazines',
        },
        productsLink: 'products/books_magazines',
        options: {
          option1: {
            name: 'Type',
            values: [
              'Fiction',
              'Popular Science',
              'Technical literature',
              'Educational literature',
              'Encyclopedias and dictionaries',
              'Magazines and comics',
              'Other literature',
            ],
          },
        },
      },
      {
        id: '3-5',
        name: 'Musical Instruments',
        img: {
          className: 'subcategory_img',
          src: 'icons/sub/musical_instruments.png',
          alt: 'Musical Instruments',
        },
        productsLink: 'products/musical_instruments',
        options: {
          option1: {
            name: 'Instruments type',
            values: [
              'Violin',
              'Viola',
              'Cello',
              'Double Bass',
              'Guitar',
              'Harp',
              'Banjo',
              'Mandolin',
              'Other String Instruments',
              'Woodwind',
              'Flute',
              'Clarinet',
              'Oboe',
              'Bassoon',
              'Saxophone',
              'Brass',
              'Trumpet',
              'Trombone',
              'French Horn',
              'Tuba',
              'Other wind Instruments',
              'Tuned',
              'Xylophone',
              'Marimba',
              'Glockenspiel',
              'Timpani',
              'Untuned',
              'Snare Drum',
              'Bass Drum',
              'Cymbals',
              'Tambourine',
              'Other Percussion Instruments',
              'Piano',
              'Organ',
              'Harpsichord',
              'Accordion',
              'Other Keyboard Instruments',
              'Synthesizer',
              'Electric Guitar',
              'Electric Bass',
              'Drum Machine',
              'Other Electronic Instruments',
              'Harmonica',
              'Bagpipes',
              'Theremin',
            ],
          },
        },
      },
      {
        id: '3-6',
        name: 'Board Games and Puzzles',
        img: {
          className: 'subcategory_img',
          src: 'icons/sub/board-game.png',
          alt: 'Board Games and Puzzles',
        },
        productsLink: 'products/board_games_puzzles',
      },
      {
        id: '3-7',
        name: 'Hunting and Fishing',
        img: {
          className: 'subcategory_img',
          src: 'icons/sub/hunting_fishing.png',
          alt: 'Hunting and Fishing',
        },
        productsLink: 'products/hunting_fishing',
      },
      {
        id: '3-8',
        name: 'Travel Gear',
        img: {
          className: 'subcategory_img',
          src: 'icons/sub/travel_gear.png',
          alt: 'Travel Gear',
        },
        productsLink: 'products/travel_gear',
        options: {
          option1: {
            name: 'Type',
            values: [
              'Travel goods',
              'Suitcases, travel bags',
              'Travel backpacks',
              'Tourist knives, multitools',
              'Tents',
              'Sleeping bags, mats',
              'Burners, camping stoves',
              'Flashlights',
              'Camping utensils',
              'Other',
            ],
          },
        },
      },
      {
        id: '3-9',
        name: 'Remote-Controlled Models',
        img: {
          className: 'subcategory_img',
          src: 'icons/sub/remote_controlled_models.png',
          alt: 'Remote-Controlled Models',
        },
        productsLink: 'products/remote_controlled_models',
      },
      {
        id: '3-10',
        name: 'Crafting',
        img: {
          className: 'subcategory_img',
          src: 'icons/sub/crafting.png',
          alt: 'Crafting',
        },
        productsLink: 'products/crafting',
        options: {
          option1: {
            name: 'Type',
            values: [
              'Materials and tools for needlework',
              'Ready-made products',
            ],
          },
        },
      },
      {
        id: '3-11',
        name: 'Sports Equipment',
        img: {
          className: 'subcategory_img',
          src: 'icons/sub/sports_equipment.png',
          alt: 'Sports Equipment',
        },
        productsLink: 'products/sports_equipment',
        option1: {
          name: 'Type',
          values: [
            'Mountaineering, hiking',
            'Badminton',
            'Trampolines',
            'Billiards',
            'Water sports',
            'Kettlebells, dumbbells',
            'Martial arts and boxing',
            'Skates',
            'Skis and snowboards',
            'Balls',
            'Rollerblades',
            'Scooters',
            'Skateboards',
            'Tennis',
            'Gyms, sports complexes',
            'Fitness, yoga',
            'Soccer',
            'Hockey',
            'Rugby',
            'Baseball',
            'Other',
          ],
        },
      },
      {
        id: '3-12',
        name: 'Bicycles',
        img: {
          className: 'subcategory_img',
          src: 'icons/sub/bicycles.png',
          alt: 'Bicycles',
        },
        productsLink: 'products/bicycles',
        options: {
          option1: {
            name: 'Type',
            values: [
              'Bmx',
              'Cargo / pedicab',
              'Cruiser',
              'Cyclocross',
              'Folding',
              'Gravel',
              'Hybrid/comfort',
              'Kids',
              'Mountain',
              'Recumbent / trike',
              'Road',
              'Tandem',
              'Track',
              'Unicycle',
              'Other',
            ],
          },
          option2: {
            name: 'Wheel size',
            values: [
              '10 in',
              '12 in',
              '14 in',
              '16 in',
              '18 in',
              '20 in',
              '24 in',
              '25 in',
              '26 in',
              '26.5 in',
              '27 in',
              '27.5 in',
              '28 in',
              '29 in',
              '650B',
              '650C',
              '700C',
              'Other',
            ],
          },
          option3: {
            name: 'Electric assist',
            values: ['None', 'Pedal assist', 'Throttle', 'Other'],
          },
          option4: {
            name: 'Brake type',
            values: [
              'Caliper',
              'Cantilever',
              'Coaster',
              'Disc (hydraulic)',
              'Disc (mechanical)',
              'Drum',
              'Gyro/bmx',
              'Hydraulic rim brakes',
              'None',
              'U-brakes',
              'V-brakes',
              'Other / unknown',
            ],
          },
          option5: {
            name: 'Handlebar type',
            values: [
              'Aero',
              'Bmx',
              'Bullhorn',
              'Cruiser',
              'Downhill',
              'Drop',
              'Flat',
              'Riser',
              'Triathlon',
              'Other / unknown',
            ],
          },
        },
      },
      {
        id: '3-13',
        name: 'Electric Transport',
        img: {
          className: 'subcategory_img',
          src: 'icons/sub/electric_transport.png',
          alt: 'Electric Transport',
        },
        productsLink: 'products/electric_transport',
        option1: {
          name: 'Handlebar type',
          values: [
            'Gyroscuters',
            'Electric scooters',
            'Other electric vehicles',
          ],
        },
      },
      {
        id: '3-14',
        name: 'Other...',
        img: {
          className: 'subcategory_img',
          src: 'icons/sub/misc_hobbies_sports.png',
          alt: 'Miscellaneous in Hobbies, Sports, and Tourism',
        },
        productsLink: 'products/misc_hobbies_sports',
      },
    ],
  },
  {
    id: '4',
    img: {
      className: 'category_img',
      src: 'icons/children.webp',
      alt: 'All_for_kids_and_moms',
    },
    link: 'All_for_kids_and_moms',
    name: 'All for Kids and Moms',
    subcategories: [
      {
        id: '4-1',
        name: 'Clothing for Infants',
        img: {
          className: 'subcategory_img',
          src: 'icons/sub/clothing_infants.png',
          alt: 'Clothing for Infants',
        },
        productsLink: 'products/clothing_infants',
      },
      {
        id: '4-2',
        name: 'Clothing for Girls',
        img: {
          className: 'subcategory_img',
          src: 'icons/sub/clothing_girls.png',
          alt: 'Clothing for Girls',
        },
        productsLink: 'products/clothing_girls',
      },
      {
        id: '4-3',
        name: 'Clothing for Boys',
        img: {
          className: 'subcategory_img',
          src: 'icons/sub/clothing_boys.png',
          alt: 'Clothing for Boys',
        },
        productsLink: 'products/clothing_boys',
      },
      {
        id: '4-4',
        name: "Children's Accessories",
        img: {
          className: 'subcategory_img',
          src: 'icons/sub/child_accessories.png',
          alt: "Children's Accessories",
        },
        productsLink: 'products/child_accessories',
      },
      {
        id: '4-5',
        name: "Children's Shoes",
        img: {
          className: 'subcategory_img',
          src: 'icons/sub/child_shoes.png',
          alt: "Children's Shoes",
        },
        productsLink: 'products/child_shoes',
      },
      {
        id: '4-6',
        name: 'Baby-walkers, Bouncers, Swings',
        img: {
          className: 'subcategory_img',
          src: 'icons/sub/baby-walker.png',
          alt: 'Baby-walkers, Bouncers, Swings',
        },
        productsLink: 'products/walkers_bouncers',
      },
      {
        id: '4-7',
        name: 'Strollers',
        img: {
          className: 'subcategory_img',
          src: 'icons/sub/stroller.png',
          alt: 'Strollers',
        },
        productsLink: 'products/strollers',
      },
      {
        id: '4-8',
        name: 'Car Seats and Boosters',
        img: {
          className: 'subcategory_img',
          src: 'icons/sub/car_seats.png',
          alt: 'Car Seats and Boosters',
        },
        productsLink: 'products/car_seats',
      },
      {
        id: '4-9',
        name: 'Feeding and Care',
        img: {
          className: 'subcategory_img',
          src: 'icons/sub/feeding_care.png',
          alt: 'Feeding and Care',
        },
        productsLink: 'products/feeding_care',
      },
      {
        id: '4-10',
        name: "Children's Textiles",
        img: {
          className: 'subcategory_img',
          src: 'icons/sub/child_textiles.png',
          alt: "Children's Textiles",
        },
        productsLink: 'products/child_textiles',
      },
      {
        id: '4-11',
        name: 'Baby Carriers and Slings',
        img: {
          className: 'subcategory_img',
          src: 'icons/sub/baby_carriers.png',
          alt: 'Baby Carriers and Slings',
        },
        productsLink: 'products/baby_carriers',
      },
      {
        id: '4-12',
        name: 'Toys and Books',
        img: {
          className: 'subcategory_img',
          src: 'icons/sub/toys_books.png',
          alt: 'Toys and Books',
        },
        productsLink: 'products/toys_books',
      },
      {
        id: '4-13',
        name: "Children's Transport",
        img: {
          className: 'subcategory_img',
          src: 'icons/sub/child_transport.png',
          alt: "Children's Transport",
        },
        productsLink: 'products/child_transport',
      },
      {
        id: '4-14',
        name: 'Products for Moms',
        img: {
          className: 'subcategory_img',
          src: 'icons/sub/products_moms.png',
          alt: 'Products for Moms',
        },
        productsLink: 'products/products_moms',
      },
      {
        id: '4-15',
        name: 'Maternity Clothing',
        img: {
          className: 'subcategory_img',
          src: 'icons/sub/maternity_clothing.png',
          alt: 'Maternity Clothing',
        },
        productsLink: 'products/maternity_clothing',
      },
    ],
  },
  {
    id: '5',
    img: {
      className: 'category_img',
      src: 'icons/furniture.webp',
      alt: 'Furniture',
    },
    link: 'Furniture',
    name: 'Furniture',
    subcategories: [
      {
        id: '5-1',
        name: 'Ottomans & Poufs',
        img: {
          className: 'subcategory_img',
          src: 'icons/sub/ottomans_poufs.png',
          alt: 'Ottomans & Poufs',
        },
        productsLink: 'products/ottomans_poufs',
      },
      {
        id: '5-2',
        name: 'Coat Racks',
        img: {
          className: 'subcategory_img',
          src: 'icons/sub/coat_racks.png',
          alt: 'Coat Racks',
        },
        productsLink: 'products/coat_racks',
      },
      {
        id: '5-3',
        name: 'Entryway Furniture',
        img: {
          className: 'subcategory_img',
          src: 'icons/sub/entryway_furniture.png',
          alt: 'Entryway Furniture',
        },
        productsLink: 'products/entryway_furniture',
      },
      {
        id: '5-4',
        name: "Children's Furniture",
        img: {
          className: 'subcategory_img',
          src: 'icons/sub/child_furniture.png',
          alt: "Children's Furniture",
        },
        productsLink: 'products/child_furniture',
      },
      {
        id: '5-5',
        name: 'Dressers',
        img: {
          className: 'subcategory_img',
          src: 'icons/sub/dressers.png',
          alt: 'Dressers',
        },
        productsLink: 'products/dressers',
      },
      {
        id: '5-6',
        name: 'Beds and Mattresses',
        img: {
          className: 'subcategory_img',
          src: 'icons/sub/beds_mattresses.png',
          alt: 'Beds and Mattresses',
        },
        productsLink: 'products/beds_mattresses',
      },
      {
        id: '5-7',
        name: 'Kitchens',
        img: {
          className: 'subcategory_img',
          src: 'icons/sub/kitchens.png',
          alt: 'Kitchens',
        },
        productsLink: 'products/kitchens',
      },
      {
        id: '5-8',
        name: 'Upholstered Furniture',
        img: {
          className: 'subcategory_img',
          src: 'icons/sub/upholstered_furniture.png',
          alt: 'Upholstered Furniture',
        },
        productsLink: 'products/upholstered_furniture',
      },
      {
        id: '5-9',
        name: 'Shelves and Cabinets',
        img: {
          className: 'subcategory_img',
          src: 'icons/sub/shelves_cabinets.png',
          alt: 'Shelves and Cabinets',
        },
        productsLink: 'products/shelves_cabinets',
      },
      {
        id: '5-10',
        name: 'Bedroom Sets',
        img: {
          className: 'subcategory_img',
          src: 'icons/sub/bedroom_sets.png',
          alt: 'Bedroom Sets',
        },
        productsLink: 'products/bedroom_sets',
      },
      {
        id: '5-12',
        name: 'Tables',
        img: {
          className: 'subcategory_img',
          src: 'icons/sub/tables.png',
          alt: 'Tables',
        },
        productsLink: 'products/tables',
      },
      {
        id: '5-13',
        name: 'Chairs',
        img: {
          className: 'subcategory_img',
          src: 'icons/sub/chairs.png',
          alt: 'Chairs',
        },
        productsLink: 'products/chairs',
      },
      {
        id: '5-14',
        name: 'Sideboards',
        img: {
          className: 'subcategory_img',
          src: 'icons/sub/sideboard.png',
          alt: 'Sideboards',
        },
        productsLink: 'products/sideboards',
      },
      {
        id: '5-15',
        name: 'Wardrobes',
        img: {
          className: 'subcategory_img',
          src: 'icons/sub/wardrobe.png',
          alt: 'Wardrobes',
        },
        productsLink: 'products/wardrobes',
      },
      {
        id: '5-16',
        name: 'Furniture fittings',
        img: {
          className: 'subcategory_img',
          src: 'icons/sub/furniture_fittings.png',
          alt: 'Furniture fittings',
        },
        productsLink: 'products/furniture_fittings',
      },
      {
        id: '5-17',
        name: 'Other Furniture',
        img: {
          className: 'subcategory_img',
          src: 'icons/sub/other_furniture.png',
          alt: 'Other Furniture',
        },
        productsLink: 'products/other_furniture',
      },
    ],
  },
  {
    id: '6',
    img: {
      className: 'category_img',
      src: 'icons/wcloths.webp',
      alt: 'Womens Wardrobe',
    },
    link: 'Womens_wardrobe',
    name: "Women's Wardrobe",
    subcategories: [
      {
        id: '6-1',
        name: "Women's Clothing",
        img: {
          className: 'subcategory_img',
          src: 'icons/sub/womens_clothing.png',
          alt: "Women's Clothing",
        },
        productsLink: 'products/womens_clothing',
      },
      {
        id: '6-2',
        name: "Women's Shoes",
        img: {
          className: 'subcategory_img',
          src: 'icons/sub/womens_shoes.png',
          alt: "Women's Shoes",
        },
        productsLink: 'products/womens_shoes',
      },
      {
        id: '6-3',
        name: "Women's Accessories",
        img: {
          className: 'subcategory_img',
          src: 'icons/sub/womens_accessories.png',
          alt: "Women's Accessories",
        },
        productsLink: 'products/womens_accessories',
      },
    ],
  },
  {
    id: '7',
    img: {
      className: 'category_img',
      src: 'icons/pets.webp',
      alt: 'Pet supplies',
    },
    link: 'Pet_supplies',
    name: 'Pet supplies',
    subcategories: [
      {
        id: '7-1',
        name: 'Pets',
        img: {
          className: 'subcategory_img',
          src: 'icons/sub/pets.png',
          alt: 'Pets',
        },
        productsLink: 'products/pets',
      },
      {
        id: '7-2',
        name: 'Farm Animals',
        img: {
          className: 'subcategory_img',
          src: 'icons/sub/farm_animals.png',
          alt: 'Farm Animals',
        },
        productsLink: 'products/farm_animals',
      },
      {
        id: '7-3',
        name: 'Pet Products',
        img: {
          className: 'subcategory_img',
          src: 'icons/sub/pet_products.png',
          alt: 'Pet Products',
        },
        productsLink: 'products/pet_products',
      },
      {
        id: '7-4',
        name: 'Animal Breeding',
        img: {
          className: 'subcategory_img',
          src: 'icons/sub/animal_breeding.png',
          alt: 'Animal Breeding',
        },
        productsLink: 'products/animal_breeding',
      },
    ],
  },
  {
    id: '8',
    img: {
      className: 'category_img',
      src: 'icons/appliances.webp',
      alt: 'Everything for home',
    },
    link: 'Everything_for_home',
    name: 'Everything for home',
    subcategories: [
      {
        id: '8-1',
        name: 'Appliances',
        img: {
          className: 'subcategory_img',
          src: 'icons/sub/appliances.png',
          alt: 'Appliances',
        },
        productsLink: 'products/appliances',
      },
      {
        id: '8-2',
        name: 'Interior Items, Mirrors',
        img: {
          className: 'subcategory_img',
          src: 'icons/sub/interior_items.png',
          alt: 'Interior Items, Mirrors',
        },
        productsLink: 'products/interior_items',
      },
      {
        id: '8-3',
        name: 'Curtains, Blinds, Cornices',
        img: {
          className: 'subcategory_img',
          src: 'icons/sub/curtains.png',
          alt: 'Curtains, Blinds, Cornices',
        },
        productsLink: 'products/curtains',
      },
      {
        id: '8-4',
        name: 'Textiles and Rugs',
        img: {
          className: 'subcategory_img',
          src: 'icons/sub/textiles_rugs.png',
          alt: 'Textiles and Rugs',
        },
        productsLink: 'products/textiles_rugs',
      },
      {
        id: '8-5',
        name: 'Household Goods',
        img: {
          className: 'subcategory_img',
          src: 'icons/sub/household_goods.png',
          alt: 'Household Goods',
        },
        productsLink: 'products/household_goods',
      },
      {
        id: '8-6',
        name: 'Dishes and Kitchen Accessories',
        img: {
          className: 'subcategory_img',
          src: 'icons/sub/dishes_kitchen_accessories.png',
          alt: 'Dishes and Kitchen Accessories',
        },
        productsLink: 'products/dishes_kitchen_accessories',
      },
    ],
  },
  {
    id: '9',
    img: {
      className: 'category_img',
      src: 'icons/mobile.webp',
      alt: 'Phones and Tablets',
    },
    link: 'Mobile_phones_and_tablets',
    name: 'Mobile phones and tablets',
    subcategories: [
      {
        id: '9-1',
        name: 'Mobile Phones',
        img: {
          className: 'subcategory_img',
          src: 'icons/sub/mobile_phones.png',
          alt: 'Mobile Phones',
        },
        productsLink: 'products/mobile_phones',
        options: {
          option1: {
            name: 'Brand',
            values: [
              'Apple',
              'AEKU',
              'AGM',
              'Airo Wireless',
              'Akai',
              'Alcatel',
              'Alcatel-Lucent',
              'AllCall',
              'Allview',
              'Altair Novus',
              'Altek',
              'Amazon',
              'AMGOO',
              'Anica',
              'ANS',
              'Acer',
              'Archos',
              'Aspera',
              'ASUS',
              'Audiovox',
              'AZUMI',
              'B&Q',
              'BALMUDA',
              'Base',
              'Bea-fon',
              'BenQ',
              'BenQ-Siemens',
              'BlackBerry',
              'Blackphone',
              'Black Shark',
              'Blackview',
              'Blaupunkt',
              'BLU',
              'Bluboo',
              'Bluechip',
              'Bosch',
              'BQ',
              'Brondi',
              'BT',
              'BZ Phone',
              'Cal-Comp',
              'CARD',
              'Casio',
              'CAT',
              'CECT',
              'Cectdigi',
              'Celkon',
              'CellAllure',
              'Cellularline',
              'Cherry Mobile',
              'China Mobile',
              'CipherLab',
              'Cisco',
              'Conquest',
              'Consumer Cellular',
              'Coolpad',
              'Cricket',
              'CROSSCALL',
              'Cubot',
              'CyberWave',
              'Cyrus',
              'Danger',
              'Dell',
              'Discovery',
              'Dmobo',
              'Doogee',
              'Doro',
              'Easyfone',
              'ECHO',
              'E-COM',
              'ecom instruments',
              'ekit',
              'Elephone',
              'emporia',
              'Energizer',
              'Ericsson',
              'Essential',
              'F(x)tec',
              'Fairphone',
              'FIGO',
              'Firefly Mobile',
              'Fitbit',
              'Flir',
              'Fonerange',
              'FreedomPop',
              'Freetel',
              'Fujitsu',
              'Fujitsu Siemens',
              'Garmin',
              'Garmin-Asus',
              'Geemarc',
              'General Mobile',
              'Geotel',
              'Getnord',
              'Gigaset',
              'Gionee',
              'Globalstar',
              'Google',
              'G-PLUS',
              'GreatCall',
              'Greentel',
              'Gresso',
              'GTstar',
              'Hafury',
              'Hagenuk',
              'Handspring',
              'Helio',
              'Hisense',
              'Hitachi',
              'HomTom',
              'Honeywell',
              'Honor',
              'Hop-on',
              'HP',
              'HTC',
              'Huadoo',
              'Huawei',
              'Hyundai',
              'iDroid',
              'iLight',
              'i-mate',
              'Indigi',
              'Infinix',
              'Inmarsat',
              'INQ',
              'Intex',
              'iPro',
              'Iridium',
              'iRulu',
              'ISHEEP',
              'Jethro',
              'Jitterbug',
              'JIVI',
              'Just5',
              'Kenxinda',
              'KOCASO',
              'Kodak',
              'Konka',
              'K-Touch',
              'Kurio',
              'Kyocera',
              'L8star',
              'Land Rover',
              'Landvo',
              'Lava',
              'Leady',
              'LEAGOO',
              'Lenovo',
              'LeTV',
              'LG',
              'Lifeline',
              'LOGIC',
              'Logicom',
              'LONG-CZ',
              'Lumigon',
              'LUNA',
              'LYF',
              'LYNXX',
              'Majestic',
              'Mann',
              'Marshall',
              'Master',
              'Maxcom',
              'Maxwest',
              'Maxx',
              'Maze',
              'MEDION',
              'Meiigoo',
              'Meitu',
              'MEIZU',
              'Melrose',
              'MFOX',
              'M-HORSE',
              'Micromax',
              'Microsoft',
              'Mio',
              'MiTAC',
              'MITO',
              'Mitsubishi',
              'MobiWire',
              'Modu',
              'MOSTHINK',
              'Motorola',
              'MyPhone',
              'NEC',
              'Newgen',
              'Nextbit',
              'NGM',
              'Noa',
              'Nokia',
              'nubia',
              'NUU',
              'NUU Mobile',
              'NYX',
              'NYX Mobile',
              'O2',
              'O2 XDA',
              'Olitech',
              'Olympia',
              'Onda',
              'OnePlus',
              'Onix',
              'ONN',
              'OPPO',
              'Optus',
              'Orange',
              'Orbic',
              'OSCAL',
              'Oukitel',
              'P.C.D.',
              'Palm',
              'Panasonic',
              'Pantech',
              'Peek',
              'Pharos',
              'Philips',
              'Planet Technology',
              'Plantronics',
              'Plum',
              'POCO',
              'Polaroid',
              'Poptel',
              'Porsche Design',
              'Posh',
              'Posh Mobile',
              'Prestigio',
              'Psion',
              'Punkt',
              'Q Mobile',
              'Qtek',
              'Qualcomm',
              'QUBO',
              'Que',
              'RadioShack',
              'Razer',
              'RCA',
              'realme',
              'Red',
              'RedMagic',
              'Redmi',
              'ROKiT',
              'Royole',
              'RugGear',
              'Runbo',
              'S&M',
              'Sagem',
              'Samsung',
              'SANYO',
              'Sciphone',
              'Seals',
              'Sharp',
              'Siemens',
              'Sierra Wireless',
              'Silent Circle',
              'SIMPLE Mobile',
              'SIRIN LABS',
              'Sky Devices',
              'Smartisan',
              'Snapfon',
              'Sonim',
              'Sony',
              'Sony Ericsson',
              'SOYES',
              'SpareOne',
              'SPC',
              'Sprint',
              'Star',
              'STK',
              'Supreme',
              'SVP',
              'Symbol',
              'TAG Heuer',
              'TCL',
              'Tecmobile',
              'Tecno',
              'TELEFUNKEN',
              'Telit',
              'TELME',
              'Telstra',
              'Tengda',
              'The Handy',
              'Thuraya',
              'TIM',
              'T-Mobile',
              'Tonino Lamborghini',
              'Torque',
              'Toshiba',
              'Toughshield',
              'TP-LINK',
              'TracFone',
              'Treo',
              'Trevi',
              'Trium',
              'TTfone',
              'Tzumi',
              'Uhans',
              'Ulefone',
              'UMi',
              'UMIDIGI',
              'UMX',
              'Unbranded',
              'Uniden',
              'Unihertz',
              'UNIWA',
              'Unnecto',
              'UTStarcom',
              'VAIO',
              'Verizon',
              'Verizon Wireless',
              'Vernee',
              'Vertu',
              'verykool',
              'ViewSonic',
              'Virgin',
              'VIVO',
              'VK Mobile',
              'Vodafone',
              'Vortex',
              'VTech',
              'WeLoveCase',
              'Wiko',
              'Wileyfox',
              'WND',
              'Xgody',
              'Xiaomi',
              'Xioami',
              'Xtreamer',
              'Yakumo',
              'Yezz',
              'YotaPhone',
              'YU',
              'Zanco',
            ],
          },
          option2: {
            name: 'Screen Size',
            values: [
              'Less than 4 in',
              '4.0 - 4.4 in',
              '4.5 - 4.9 in',
              '5.0 - 5.4 in',
              '5.5 - 5.9 in',
              '6 in or more',
            ],
          },
          option3: {
            name: 'RAM',
            values: [
              '8 MB',
              '64 MB',
              '512 MB',
              '1 GB',
              '2 GB',
              '3 GB',
              '4 GB',
              '5 GB',
              '6 GB',
              '7 GB',
              '8 GB',
              '10 GB',
              '12 GB',
              '16 GB',
            ],
          },
          option4: {
            name: 'Storage Capacity',
            values: [
              '8 GB or less',
              '16 GB',
              '32 GB',
              '64 GB',
              '128 GB',
              '256 GB',
              '512 GB',
              '1TB and more',
            ],
          },
          option5: {
            name: 'SIM Card Slot',
            values: [
              'Dual SIM (SIM + eSIM)',
              'Dual SIM (SIM + SIM/Memory Card)',
              'Dual SIM (SIM + SIM)',
              'Dual SIM (SIM + SIM + Memory Card)',
              'eSIM',
              'Quad SIM',
              'Single SIM',
              'Triple SIM',
            ],
          },
          option6: {
            name: 'Video recording',
            values: ['HD 720p', 'Full HD 1080p', '2K', '4K', '8K'],
          },
        },
      },
      {
        id: '9-2',
        name: 'Phone Components',
        img: {
          className: 'subcategory_img',
          src: 'icons/sub/phone_components.png',
          alt: 'Phone Components',
        },
        productsLink: 'products/phone_components',
        options: {
          option1: {
            name: 'Type',
            values: [
              'Batteries',
              'Speakers',
              'Cameras',
              'Case parts',
              'Tablets for spare parts',
              'Boards',
              'Touchscreens, displays, matrices',
              'Cables',
            ],
          },
        },
      },
      {
        id: '9-3',
        name: 'Phone Accessories',
        img: {
          className: 'subcategory_img',
          src: 'icons/sub/phone_accessories.png',
          alt: 'Phone Accessories',
        },
        productsLink: 'products/phone_accessories',
        options: {
          option1: {
            name: 'Type',
            values: [
              'Bluetooth headset',
              'Car holders',
              'Chargers',
              'Covers, cases',
              'Cables and adapters',
              'Electronic stabilizers',
              'Memory cards',
              'Selfie sticks',
              'Films, glasses',
              'Portable chargers',
              'Other accessories',
            ],
          },
        },
      },
      {
        id: '9-4',
        name: 'Telephony and Communication',
        img: {
          className: 'subcategory_img',
          src: 'icons/sub/telephony_communication.png',
          alt: 'Telephony and Communication',
        },
        productsLink: 'products/telephony_communication',
        options: {
          option1: {
            name: 'Type',
            values: [
              'Corded telephones',
              'Radio telephones',
              'Walkie-talkies',
              'Other',
            ],
          },
        },
      },
      {
        id: '9-5',
        name: 'Tablets',
        img: {
          className: 'subcategory_img',
          src: 'icons/sub/tablets.png',
          alt: 'Tablets',
        },
        productsLink: 'products/tablets',
        options: {
          option1: {
            name: 'Brand',
            values: [
              '1byone',
              '3M',
              'Apple',
              'ACE',
              'Acepad',
              'Acer',
              'Acme',
              'Acme Made',
              'Adesso',
              'Adidas',
              'Adonit',
              'Aduro',
              'Alcatel',
              'ALLDOCUBE',
              'Amazon',
              'AmazonBasics',
              'amFilm',
              'Amzer',
              'Anker',
              'Archos',
              'Arkon',
              'ASUS',
              'Atari',
              'Axiom',
              'Azpen',
              'Bamboo',
              'Barnes & Noble',
              'BASEUS',
              'Bauhn',
              'Be-ez',
              'Belkin',
              'Betsey Johnson',
              'Black',
              'BlackBerry',
              'BMW',
              'BODHI',
              'Body Glove',
              'Boogie Board',
              'Boriyuan',
              'Bretford',
              'Brookstone',
              'Brother',
              'Brydge',
              'BUBM',
              'Buffalo',
              'Bugatti',
              'BUILT',
              'Burberry',
              'Cameron Sino',
              'CaseCrown',
              'Case Logic',
              'CAT',
              'CHANEL',
              'Chicony',
              'Chuwi',
              'Cirago',
              'Coach',
              'Coby',
              'Compaq',
              'Contixo',
              'Cotytech',
              'Craig',
              'Crane',
              'Crayola',
              'Crestron',
              'Cygnett',
              'Davis',
              'DC Comics',
              'Dell',
              'DICOTA',
              'Diesel',
              'Digital2',
              'Disney',
              'DJI',
              'DOOGEE',
              'Dragon Touch',
              'DSLRKIT',
              'Dsquared2',
              'Duracell',
              'EasyAcc',
              'Efun',
              'ELECOM',
              'Emoji',
              'Esperanza',
              'ESR',
              'EZGuardZ',
              'Fellowes',
              'Filemate',
              'Fintie',
              'Fosmon',
              'Fossil',
              'Fujitsu',
              'Galaxy',
              'Garmin',
              'Gear4',
              'Gecko',
              'GelaSkins',
              'General',
              'Getac',
              'Golla',
              'Google',
              'Griffin',
              'Gucci',
              'GUESS',
              'Haier',
              'Hama',
              'Hannspree',
              'Harry Potter',
              'Hasbro',
              'Head Case Designs',
              'Hello Kitty',
              'Herschel',
              'Hipstreet',
              'Honeywell',
              'HP',
              'HTC',
              'Huawei',
              'Huion',
              'IBM',
              'iFrogz',
              'iGo',
              'iHarbort',
              'iHome',
              'IKEA',
              'IK Multimedia',
              'iLuv',
              'iMicro',
              'Inateck',
              'Incase',
              'Incipio',
              'Infiland',
              'inland',
              'InLine',
              'inno-in',
              'Insignia',
              'Insten',
              'Intel',
              'iPort',
              'iRiver',
              'iRulu',
              'iSimple',
              'iSound',
              'IT',
              'IVSO',
              'JadaCase',
              'Jelly Comb',
              'JETech',
              'Joy',
              'Juicy Couture',
              'K & M',
              'Kanex',
              'KARYLAX',
              'kate spade new york',
              'Kenneth Cole Reaction',
              'Kensington',
              'Knomo',
              'Kobo',
              'KOCASO',
              'Kroo',
              'Kurio',
              'kwmobile',
              'LapGear',
              'Laurel Burch',
              'LeapFrog',
              'Leitz',
              'Lenovo',
              'Levenger',
              'Lexibook',
              'LG',
              'Lifeworks',
              'Lilly Pulitzer',
              'LINKIT',
              'Linx',
              'Logic3',
              'Logitech',
              'Louis Vuitton',
              'Lowepro',
              'Lucky Brand',
              'Lupo',
              'Macally',
              'Magic',
              'Manhattan',
              'Marc Jacobs',
              'Marware',
              'Maxwest',
              'Me & Ko',
              'M-Edge',
              'MediaCom',
              'MEDION',
              'Merkury',
              'Metro',
              'Michael Kors',
              'Microsoft',
              'MINI',
              'Modal',
              'MoKo',
              'Moleskine',
              'Monika Strigel',
              'Monster',
              'mophie',
              'Moshi',
              'Motion',
              'Motorola',
              'Mumbi',
              'MYBAT',
              'nabi',
              'Neewer',
              'New Trent',
              'Nexstand',
              'Nextbook',
              'Nexus',
              'Nintendo',
              'Nobis',
              'Nokia',
              'Nook',
              'NOVA',
              'NuVision',
              'NVIDIA',
              'Onda',
              'ONN',
              'Onyx',
              'Orbo',
              'Oregon Scientific',
              'Osmo',
              'OTTERBOX',
              'Packard Bell',
              'Palm',
              'Panasonic',
              'Pandigital',
              'Pantech',
              'Philips',
              'Plantronics',
              'Platinum',
              'PLUS',
              'PocketBook',
              'Poetic',
              'Polaroid',
              'Porsche Design',
              'PORT',
              'PORT Designs',
              'PRADA',
              'Premiertek',
              'Premium',
              'Prestigio',
              'ProCase',
              'Proenza Schouler',
              'PureGear',
              'RadioShack',
              'Rain Design',
              'Ralph Lauren',
              'RAM',
              'RAM Mounts',
              'RCA',
              'Rocketfish',
              'Roocase',
              'Sakar',
              'Sakroots',
              'Salvatore Ferragamo',
              'SAMDIS',
              'Samsonite',
              'Samsung',
              'Sandstrom',
              'Sanrio',
              'Sanwa Supply',
              'Satechi',
              'Scosche',
              'Setwear Products',
              'SGP',
              'Sharper Image',
              'Skinit',
              'Smartab',
              'Smatree',
              'Solo',
              'Sony',
              'Sony Ericsson',
              'Speck',
              'SPEED LINK',
              'Spigen',
              'Square',
              'StarTech',
              'STM',
              'SUPCASE',
              'SWISSGEAR',
              'Symbol',
              'Tagital',
              'TaoTronics',
              'Targus',
              'Tech21',
              'Tech Armor',
              'Techmade',
              'Teclast',
              'Ted Baker',
              'TFY',
              'The Friendly Swede',
              'Thomson',
              'TomTom',
              'Top Case',
              'Tory Burch',
              'Toshiba',
              'Transcend',
              'TREKSTOR',
              'Tribeca',
              'Trident',
              'Trio',
              'TROIKA',
              'Trust',
              'Tucano',
              'Tuffluv',
              'Tumi',
              'Twelve South',
              'Ugreen',
              'Ultimate',
              'Ultimate Arms Gear',
              'Ultra',
              'Unbranded',
              'Universal',
              'URBAN ARMOR GEAR',
              'uxcell',
              'V7',
              'Veho',
              'Vera Bradley',
              'Verbatim',
              'Verizon',
              'Verso',
              'VIBE',
              'Victory',
              'ViewSonic',
              'Vivitar',
              'VIVO',
              'VIZIO',
              "Vogel's",
              'Wacom',
              'Wigento',
              'WWE',
              'Xiaomi',
              'XPLORE',
              'Xp-pen',
              'Xtreme',
              'Yekbee',
              'Yoobao',
              'Yuntab',
              'ZAGG',
              'Zebra',
            ],
          },
          option2: {
            name: 'Screen Size',
            values: [
              'Less than 6 in',
              '6 in',
              '7 in',
              '8 in',
              '9 in',
              '10 in',
              '11 in',
              '12 in and more',
            ],
          },
          option3: {
            name: 'RAM',
            values: [
              '1 GB and less',
              '2 GB',
              '3 GB',
              '4 GB',
              '5 GB',
              '6 GB',
              '7 GB',
              '8 GB',
              '10 GB',
              '12 GB',
              '16 GB and more',
            ],
          },
          option4: {
            name: 'Storage Capacity',
            values: [
              '8 GB or less',
              '16 GB',
              '32 GB',
              '64 GB',
              '128 GB',
              '256 GB',
              '512 GB',
              '1TB and more',
            ],
          },
          option5: {
            name: 'Operating system',
            values: ['Android', 'IOS', 'Windows', 'Other'],
          },
          option6: {
            name: 'SIM card',
            values: ['Yes', 'No'],
          },
        },
      },
      {
        id: '9-6',
        name: 'Graphic Tablets',
        img: {
          className: 'subcategory_img',
          src: 'icons/sub/graphic_tablets.png',
          alt: 'Graphic Tablets',
        },
        productsLink: 'products/graphic_tablets',
        options: {
          option1: {
            name: 'Brand',
            values: [
              'Gaomon',
              'Huion',
              'Parblo',
              'Gaomon',
              'Ugee',
              'Wacom',
              'XP-Pen',
              'Other',
            ],
          },
        },
      },
      {
        id: '9-7',
        name: 'E-Readers',
        img: {
          className: 'subcategory_img',
          src: 'icons/sub/e_readers.png',
          alt: 'E-Readers',
        },
        productsLink: 'products/e_readers',
        options: {
          option1: {
            name: 'Brand',
            values: [
              'Amazon',
              'Digma',
              'Onyx',
              'PocketBook',
              'Ritmix',
              'Other',
            ],
          },
        },
      },
      {
        id: '9-8',
        name: 'Smart Watches and Fitness Trackers',
        img: {
          className: 'subcategory_img',
          src: 'icons/sub/smart_watches.png',
          alt: 'Smart Watches and Fitness Trackers',
        },
        productsLink: 'products/smart_watches',
        options: {
          option1: {
            name: 'Brand',
            values: [
              'Apple',
              'ABYX',
              'Acer',
              'Alcatel',
              'Alpina',
              'Amazfit',
              'Androidly',
              'ARPSTAR',
              'ASUS',
              'Blackview',
              'Burg',
              'Casio',
              'Cawono',
              'Chereeki',
              'Citizen',
              'COGITO',
              'COLMI',
              'Cubot',
              'Diesel',
              'Diggro',
              'Doro',
              'Elephone',
              'Emporio Armani',
              'Fitbit',
              'Fit Smart',
              'Fossil',
              'Garmin',
              'GUESS',
              'Honor',
              'HOT Watch',
              'Huawei',
              'Hublot',
              'IOWODO',
              'iTOUCH',
              'Kate spade new york',
              'Kospet',
              'Kronaby',
              'Kurio',
              'Kydo',
              'LEMFO',
              'Lenovo',
              'Letscom',
              'Letsfit',
              'LG',
              'LOKMAT',
              'Magellan',
              'MetaWatch',
              'Michael Kors',
              'Microsoft',
              'Misfit',
              'Mobvoi',
              'Montblanc',
              'Motorola',
              'Movado',
              'Mykronoz',
              'New Balance',
              'Nike',
              'Nixon',
              'Nokia',
              'OUKITEL',
              'Pebble',
              'PELTEC',
              'Polar',
              'PUMA',
              'Qualcomm',
              'Razer',
              'RWATCH',
              'Samsung',
              'Skagen',
              'SKMEI',
              'Sony',
              'Suunto',
              'Swatch',
              'TAG Heuer',
              'The No.1',
              'Timex',
              'Titan',
              'Tommy Hilfiger',
              'TomTom',
              'Toobur',
              'UMIDIGI',
              'Unbranded',
              'Verizon',
              'VTech',
              'Willful',
              'Withings',
              'XCSOURCE',
              'Xiaomi',
              'Yamay',
              'ZEBLAZE',
              'ZGPAX',
              'ZTE',
              'Other',
            ],
          },
          option2: {
            name: 'Case Size',
            values: [
              '18 mm',
              '20 mm',
              '22 mm',
              '23 mm',
              '24 mm',
              '25 mm',
              '26 mm',
              '27 mm',
              '28 mm',
              '29 mm',
              '30 mm',
              '31 mm',
              '32 mm',
              '33 mm',
              '34 mm',
              '35 mm',
              '36 mm',
              '37 mm',
              '38 mm',
              '39 mm',
              '40 mm',
              '41 mm',
              '42 mm',
              '43 mm',
              '44 mm',
              '45 mm',
              '46 mm',
              '47 mm',
              '48 mm',
              '49 mm',
              '50 mm',
              '51 mm',
              '52 mm',
            ],
          },
          option3: {
            name: 'Own SIM card',
            values: ['Yes', 'No'],
          },
          option4: {
            name: 'Water resistance',
            values: ['Yes', 'No'],
          },
        },
      },
      {
        id: '9-9',
        name: 'Accessories for Tablets, Books, and Watches',
        img: {
          className: 'subcategory_img',
          src: 'icons/sub/tablet_book_watch_accessories.png',
          alt: 'Accessories for Tablets, Books, and Watches',
        },
        productsLink: 'products/tablet_book_watch_accessories',
        options: {
          option1: {
            name: 'Type',
            values: [
              'Chargers',
              'Cables and adapters',
              'Watch bands',
              'Films, glasses',
              'Covers, cases',
              'Other accessories',
            ],
          },
        },
      },
    ],
  },
  {
    id: '10',
    img: {
      className: 'category_img',
      src: 'icons/electronics.webp',
      alt: 'Electronics',
    },
    link: 'Electronics',
    name: 'Electronics',
    subcategories: [
      {
        id: '10-1',
        name: 'Audio Equipment',
        img: {
          className: 'subcategory_img',
          src: 'icons/sub/audio_equipment.png',
          alt: 'Audio Equipment',
        },
        productsLink: 'products/audio_equipment',
      },
      {
        id: '10-2',
        name: 'Headphones',
        img: {
          className: 'subcategory_img',
          src: 'icons/sub/headphones.png',
          alt: 'Headphones',
        },
        productsLink: 'products/headphones',
      },
      {
        id: '10-3',
        name: 'TV and Video Equipment',
        img: {
          className: 'subcategory_img',
          src: 'icons/sub/tv_video_equipment.png',
          alt: 'TV and Video Equipment',
        },
        productsLink: 'products/tv_video_equipment',
      },
      {
        id: '10-4',
        name: 'Camera and Optics',
        img: {
          className: 'subcategory_img',
          src: 'icons/sub/camera_optics.png',
          alt: 'Camera and Optics',
        },
        productsLink: 'products/camera_optics',
      },
      {
        id: '10-5',
        name: 'Consoles and Games',
        img: {
          className: 'subcategory_img',
          src: 'icons/sub/consoles_games.png',
          alt: 'Consoles and Games',
        },
        productsLink: 'products/consoles_games',
      },
      {
        id: '10-6',
        name: 'Security Systems and Smart Home',
        img: {
          className: 'subcategory_img',
          src: 'icons/sub/security_systems.png',
          alt: 'Security Systems and Smart Home',
        },
        productsLink: 'products/security_systems',
      },
    ],
  },
  {
    id: '11',
    img: {
      className: 'category_img',
      src: 'icons/PC.webp',
      alt: 'Computer Equipment',
    },
    link: 'Computer_equipment',
    name: 'Computer Equipment',
    subcategories: [
      {
        id: '11-1',
        name: 'Laptops',
        img: {
          className: 'subcategory_img',
          src: 'icons/sub/laptops.png',
          alt: 'Laptops',
        },
        productsLink: 'products/laptops',
      },
      {
        id: '11-2',
        name: 'Computers and CPU Units',
        img: {
          className: 'subcategory_img',
          src: 'icons/sub/computers_cpu_units.png',
          alt: 'Computers and CPU Units',
        },
        productsLink: 'products/computers_cpu_units',
      },
      {
        id: '11-3',
        name: 'Monitors',
        img: {
          className: 'subcategory_img',
          src: 'icons/sub/monitors.png',
          alt: 'Monitors',
        },
        productsLink: 'products/monitors',
      },
      {
        id: '11-4',
        name: 'Computer Components',
        img: {
          className: 'subcategory_img',
          src: 'icons/sub/computer_components.png',
          alt: 'Computer Components',
        },
        productsLink: 'products/computer_components',
      },
      {
        id: '11-5',
        name: 'Office Equipment',
        img: {
          className: 'subcategory_img',
          src: 'icons/sub/office_equipment.png',
          alt: 'Office Equipment',
        },
        productsLink: 'products/office_equipment',
      },
      {
        id: '11-6',
        name: 'Peripheral Devices and Accessories',
        img: {
          className: 'subcategory_img',
          src: 'icons/sub/peripheral_devices.png',
          alt: 'Peripheral Devices and Accessories',
        },
        productsLink: 'products/peripheral_devices',
      },
      {
        id: '11-7',
        name: 'Networking Equipment',
        img: {
          className: 'subcategory_img',
          src: 'icons/sub/networking_equipment.png',
          alt: 'Networking Equipment',
        },
        productsLink: 'products/networking_equipment',
      },
      {
        id: '11-8',
        name: 'Other Computer Products',
        img: {
          className: 'subcategory_img',
          src: 'icons/sub/other_computer_products.png',
          alt: 'Other Computer Products',
        },
        productsLink: 'products/other_computer_products',
      },
    ],
  },
  {
    id: '12',
    img: {
      className: 'category_img',
      src: 'icons/cloths.webp',
      alt: "Men's Wardrobe",
    },
    link: 'Men&apos;s_wardrobe',
    name: "Men's Wardrobe",
    subcategories: [
      {
        id: '12-1',
        name: "Men's Clothing",
        img: {
          className: 'subcategory_img',
          src: 'icons/sub/mens_clothing.png',
          alt: "Men's Clothing",
        },
        productsLink: 'products/mens_clothing',
      },
      {
        id: '12-2',
        name: "Men's Shoes",
        img: {
          className: 'subcategory_img',
          src: 'icons/sub/mens_shoes.png',
          alt: "Men's Shoes",
        },
        productsLink: 'products/mens_shoes',
      },
      {
        id: '12-3',
        name: "Men's Accessories",
        img: {
          className: 'subcategory_img',
          src: 'icons/sub/mens_accessories.png',
          alt: "Men's Accessories",
        },
        productsLink: 'products/mens_accessories',
      },
    ],
  },
  {
    id: '13',
    img: {
      className: 'category_img',
      src: 'icons/work.webp',
      alt: 'Services, Jobs',
    },
    link: 'Services_and_jobs',
    name: 'Services and jobs',
    subcategories: [
      {
        id: '13-1',
        name: 'Auto Services',
        img: {
          className: 'subcategory_img',
          src: 'icons/sub/auto_services.png',
          alt: 'Auto Services',
        },
        productsLink: 'products/auto_services',
      },
      {
        id: '13-2',
        name: 'Home Services',
        img: {
          className: 'subcategory_img',
          src: 'icons/sub/home_services.png',
          alt: 'Home Services',
        },
        productsLink: 'products/home_services',
      },
      {
        id: '13-3',
        name: 'Computer and Internet Services',
        img: {
          className: 'subcategory_img',
          src: 'icons/sub/computer_internet_services.png',
          alt: 'Computer and Internet Services',
        },
        productsLink: 'products/computer_internet_services',
      },
      {
        id: '13-4',
        name: 'Repair of Technology and Electronics',
        img: {
          className: 'subcategory_img',
          src: 'icons/sub/repair_technology.png',
          alt: 'Repair of Technology and Electronics',
        },
        productsLink: 'products/repair_technology',
      },
      {
        id: '13-5',
        name: 'Beauty and Health',
        img: {
          className: 'subcategory_img',
          src: 'icons/sub/beauty_health.png',
          alt: 'Beauty and Health',
        },
        productsLink: 'products/beauty_health',
      },
      {
        id: '13-6',
        name: 'Nanny and Caregiver Services',
        img: {
          className: 'subcategory_img',
          src: 'icons/sub/nanny_caregiver_services.png',
          alt: 'Nanny and Caregiver Services',
        },
        productsLink: 'products/nanny_caregiver_services',
      },
      {
        id: '13-7',
        name: 'Educational Services',
        img: {
          className: 'subcategory_img',
          src: 'icons/sub/educational_services.png',
          alt: 'Educational Services',
        },
        productsLink: 'products/educational_services',
      },
      {
        id: '13-8',
        name: 'Translation and Secretarial Services',
        img: {
          className: 'subcategory_img',
          src: 'icons/sub/translation_secretarial_services.png',
          alt: 'Translation and Secretarial Services',
        },
        productsLink: 'products/translation_secretarial_services',
      },
      {
        id: '13-9',
        name: 'Passenger and Cargo Transport',
        img: {
          className: 'subcategory_img',
          src: 'icons/sub/passenger_cargo_transport.png',
          alt: 'Passenger and Cargo Transport',
        },
        productsLink: 'products/passenger_cargo_transport',
      },
      {
        id: '13-10',
        name: 'Advertising and Printing',
        img: {
          className: 'subcategory_img',
          src: 'icons/sub/advertising_printing.png',
          alt: 'Advertising and Printing',
        },
        productsLink: 'products/advertising_printing',
      },
      {
        id: '13-11',
        name: 'Construction Work',
        img: {
          className: 'subcategory_img',
          src: 'icons/sub/construction_work.png',
          alt: 'Construction Work',
        },
        productsLink: 'products/construction_work',
      },
      {
        id: '13-12',
        name: 'Apartment and House Repairs',
        img: {
          className: 'subcategory_img',
          src: 'icons/sub/apartment_house_repairs.png',
          alt: 'Apartment and House Repairs',
        },
        productsLink: 'products/apartment_house_repairs',
      },
      {
        id: '13-13',
        name: 'Furniture Repair and Assembly',
        img: {
          className: 'subcategory_img',
          src: 'icons/sub/furniture_repair_assembly.png',
          alt: 'Furniture Repair and Assembly',
        },
        productsLink: 'products/furniture_repair_assembly',
      },
      {
        id: '13-14',
        name: 'Clothing Repair and Tailoring',
        img: {
          className: 'subcategory_img',
          src: 'icons/sub/clothing_repair_tailoring.png',
          alt: 'Clothing Repair and Tailoring',
        },
        productsLink: 'products/clothing_repair_tailoring',
      },
      {
        id: '13-15',
        name: 'Garden Maintenance',
        img: {
          className: 'subcategory_img',
          src: 'icons/sub/garden_maintenance.png',
          alt: 'Garden Maintenance',
        },
        productsLink: 'products/garden_maintenance',
      },
      {
        id: '13-16',
        name: 'Pet Services',
        img: {
          className: 'subcategory_img',
          src: 'icons/sub/pet_services_jobs.png',
          alt: 'Pet Services',
        },
        productsLink: 'products/pet_services_jobs',
      },
      {
        id: '13-17',
        name: 'Event Services',
        img: {
          className: 'subcategory_img',
          src: 'icons/sub/event_services.png',
          alt: 'Event Services',
        },
        productsLink: 'products/event_services',
      },
      {
        id: '13-18',
        name: 'Photography and Videography',
        img: {
          className: 'subcategory_img',
          src: 'icons/sub/photography_videography.png',
          alt: 'Photography and Videography',
        },
        productsLink: 'products/photography_videography',
      },
      {
        id: '13-19',
        name: 'Legal Services',
        img: {
          className: 'subcategory_img',
          src: 'icons/sub/legal_services.png',
          alt: 'Legal Services',
        },
        productsLink: 'products/legal_services',
      },
      {
        id: '13-20',
        name: 'Travel Services',
        img: {
          className: 'subcategory_img',
          src: 'icons/sub/travel_services.png',
          alt: 'Travel Services',
        },
        productsLink: 'products/travel_services_jobs',
      },
      {
        id: '13-21',
        name: 'Other Services',
        img: {
          className: 'subcategory_img',
          src: 'icons/sub/misc_services.png',
          alt: 'Other Services',
        },
        productsLink: 'products/misc_services',
      },
      {
        id: '13-22',
        name: 'Job Vacancies',
        img: {
          className: 'subcategory_img',
          src: 'icons/sub/job_vacancies.png',
          alt: 'Job Vacancies',
        },
        productsLink: 'products/job_vacancies',
      },
    ],
  },
  {
    id: '14',
    img: {
      className: 'category_img',
      src: 'icons/business.webp',
      alt: 'Ready-made Business and Equipment',
    },
    link: 'Ready-made_business_and_equipment',
    name: 'Ready-made Business and Equipment',
    subcategories: [
      {
        id: '14-1',
        name: 'Ready-made Business',
        img: {
          className: 'subcategory_img',
          src: 'icons/sub/ready_made_business.png',
          alt: 'Ready-made Business',
        },
        productsLink: 'products/ready_made_business',
      },
      {
        id: '14-2',
        name: 'Business Equipment',
        img: {
          className: 'subcategory_img',
          src: 'icons/sub/business_equipment.png',
          alt: 'Business Equipment',
        },
        productsLink: 'products/business_equipment',
      },
    ],
  },
  {
    id: '15',
    img: {
      className: 'category_img',
      src: 'icons/beauty.webp',
      alt: 'Beauty and Health',
    },
    link: 'Beauty_and_health',
    name: 'Beauty and health',
    subcategories: [
      {
        id: '15-1',
        name: 'Cosmetics',
        img: {
          className: 'subcategory_img',
          src: 'icons/sub/cosmetics.png',
          alt: 'Cosmetics',
        },
        productsLink: 'products/cosmetics',
      },
      {
        id: '15-2',
        name: 'Perfumes',
        img: {
          className: 'subcategory_img',
          src: 'icons/sub/perfumes.png',
          alt: 'Perfumes',
        },
        productsLink: 'products/perfumes',
      },
      {
        id: '15-3',
        name: 'Manicure and Pedicure',
        img: {
          className: 'subcategory_img',
          src: 'icons/sub/manicure_pedicure.png',
          alt: 'Manicure and Pedicure',
        },
        productsLink: 'products/manicure_pedicure',
      },
      {
        id: '15-4',
        name: 'Hair Care Products',
        img: {
          className: 'subcategory_img',
          src: 'icons/sub/hair_care.png',
          alt: 'Hair Care Products',
        },
        productsLink: 'products/hair_care',
      },
      {
        id: '15-5',
        name: 'Hygiene and Depilation Products',
        img: {
          className: 'subcategory_img',
          src: 'icons/sub/hygiene_depilation.png',
          alt: 'Hygiene and Depilation Products',
        },
        productsLink: 'products/hygiene_depilation',
      },
      {
        id: '15-6',
        name: 'Eyelashes and Brows, Tattoos',
        img: {
          className: 'subcategory_img',
          src: 'icons/sub/eyelashes_brows.png',
          alt: 'Eyelashes and Brows, Tattoos',
        },
        productsLink: 'products/eyelashes_brows',
      },
      {
        id: '15-7',
        name: 'Cosmetic Accessories',
        img: {
          className: 'subcategory_img',
          src: 'icons/sub/cosmetic_accessories.png',
          alt: 'Cosmetic Accessories',
        },
        productsLink: 'products/cosmetic_accessories',
      },
      {
        id: '15-8',
        name: 'Medical Products',
        img: {
          className: 'subcategory_img',
          src: 'icons/sub/medical_products.png',
          alt: 'Medical products',
        },
        productsLink: 'products/medical_products',
      },
    ],
  },

  {
    id: '16',
    img: {
      className: 'category_img',
      src: 'icons/wedding.webp',
      alt: 'Weddings and Holidays',
    },
    link: 'Weddings_and_holidays',
    name: 'Weddings and holidays',
    subcategories: [
      {
        id: '16-1',
        name: 'Wedding Dresses',
        img: {
          className: 'subcategory_img',
          src: 'icons/sub/wedding_dresses.png',
          alt: 'Wedding Dresses',
        },
        productsLink: 'products/wedding_dresses',
      },
      {
        id: '16-2',
        name: 'Wedding Suits',
        img: {
          className: 'subcategory_img',
          src: 'icons/sub/wedding_suits.png',
          alt: 'Wedding Suits',
        },
        productsLink: 'products/wedding_suits',
      },
      {
        id: '16-3',
        name: 'Wedding Shoes',
        img: {
          className: 'subcategory_img',
          src: 'icons/sub/wedding_shoes.png',
          alt: 'Wedding Shoes',
        },
        productsLink: 'products/wedding_shoes',
      },
      {
        id: '16-4',
        name: 'Wedding Accessories',
        img: {
          className: 'subcategory_img',
          src: 'icons/sub/wedding_accessories.png',
          alt: 'Wedding Accessories',
        },
        productsLink: 'products/wedding_accessories',
      },
      {
        id: '16-5',
        name: 'Gifts and Holiday Supplies',
        img: {
          className: 'subcategory_img',
          src: 'icons/sub/gifts_holiday_supplies.png',
          alt: 'Gifts and Holiday Supplies',
        },
        productsLink: 'products/gifts_holiday_supplies',
      },
      {
        id: '16-6',
        name: 'Costumes for Festivals',
        img: {
          className: 'subcategory_img',
          src: 'icons/sub/costumes_festivals.png',
          alt: 'Costumes for Festivals',
        },
        productsLink: 'products/costumes_festivals',
      },
    ],
  },

  {
    id: '17',
    img: {
      className: 'category_img',
      src: 'icons/gardening.webp',
      alt: 'Garden & Outdoor',
    },
    link: 'Garden_&_outdoor',
    name: 'Garden & Outdoor',
    subcategories: [
      {
        id: '17-1',
        name: 'Garden Furniture and Pools',
        img: {
          className: 'subcategory_img',
          src: 'icons/sub/garden_furniture_pools.png',
          alt: 'Garden Furniture and Pools',
        },
        productsLink: 'products/garden_furniture_pools',
      },
      {
        id: '17-2',
        name: 'Grills, Accessories, Fuel',
        img: {
          className: 'subcategory_img',
          src: 'icons/sub/grills.png',
          alt: 'Grills, Accessories, Fuel',
        },
        productsLink: 'products/grills_accessories_fuel',
      },
      {
        id: '17-3',
        name: 'Cultivators and Tillers',
        img: {
          className: 'subcategory_img',
          src: 'icons/sub/cultivators_tillers.png',
          alt: 'Cultivators and Tillers',
        },
        productsLink: 'products/cultivators_tillers',
      },
      {
        id: '17-4',
        name: 'Garden Equipment',
        img: {
          className: 'subcategory_img',
          src: 'icons/sub/garden_equipment.png',
          alt: 'Garden Equipment',
        },
        productsLink: 'products/garden_equipment',
      },
      {
        id: '17-5',
        name: 'Garden Tools',
        img: {
          className: 'subcategory_img',
          src: 'icons/sub/garden_tools.png',
          alt: 'Garden Tools',
        },
        productsLink: 'products/garden_tools',
      },
      {
        id: '17-6',
        name: 'Greenhouses and Hotbeds',
        img: {
          className: 'subcategory_img',
          src: 'icons/sub/greenhouses_hotbeds.png',
          alt: 'Greenhouses and Hotbeds',
        },
        productsLink: 'products/greenhouses_hotbeds',
      },
      {
        id: '17-7',
        name: 'Plants and Seeds for the Garden',
        img: {
          className: 'subcategory_img',
          src: 'icons/sub/plants_seeds.png',
          alt: 'Plants and Seeds for the Garden',
        },
        productsLink: 'products/plants_seeds',
      },
      {
        id: '17-8',
        name: 'Fertilizers and Agrochemicals',
        img: {
          className: 'subcategory_img',
          src: 'icons/sub/fertilizers_agrochemicals.png',
          alt: 'Fertilizers and Agrochemicals',
        },
        productsLink: 'products/fertilizers_agrochemicals',
      },
      {
        id: '17-9',
        name: 'Everything for Beekeeping',
        img: {
          className: 'subcategory_img',
          src: 'icons/sub/beekeeping.png',
          alt: 'Everything for Beekeeping',
        },
        productsLink: 'products/everything_beekeeping',
      },
      {
        id: '17-10',
        name: 'Bathhouses, Utility Sheds, Restrooms',
        img: {
          className: 'subcategory_img',
          src: 'icons/sub/bathhouses_sheds_restrooms.png',
          alt: 'Bathhouses, Utility Sheds, Restrooms',
        },
        productsLink: 'products/bathhouses_sheds_restrooms',
      },
      {
        id: '17-11',
        name: 'Other for Garden',
        img: {
          className: 'subcategory_img',
          src: 'icons/sub/other_garden.png',
          alt: 'Miscellaneous for Garden and Vegetable Garden',
        },
        productsLink: 'products/miscellaneous_garden_vegetable_garden',
      },
    ],
  },
  {
    id: '18',
    img: {
      className: 'category_img',
      src: 'icons/realty.webp',
      alt: 'Real Estate',
    },
    link: 'Real_estate',
    name: 'Real Estate',
    subcategories: [
      {
        id: '18-1',
        name: 'Residential Real Estate for Rent',
        img: {
          className: 'subcategory_img',
          src: 'icons/sub/house.svg',
          alt: 'Residential Real Estate for Rent',
        },
        productsLink: 'products/residential_real_estate_rent',
        options: {
          option1: {
            name: 'Type of residential property',
            values: [
              'Cottage',
              'Condo',
              'Flat',
              'Loft',
              'Apartment',
              'Townhouse',
              'Duplex',
              'Triplex',
              'Mobile Home',
              'Other',
            ],
          },
          option2: {
            name: 'Rent period',
            values: ['Daily', 'Weekly', 'Monthly', 'Long term'],
          },
          option3: {
            name: 'Furnished?',
            values: ['Yes', 'No'],
          },
          option4: {
            name: 'Bedrooms qty',
            values: ['0', '1', '2', '3', '4', '5', '6 and more'],
          },
          option5: {
            name: 'Bathrooms qty',
            values: ['0', '1', '2', '3', '4', '5 and more'],
          },
          option6: {
            name: 'Domestic animals ok?',
            values: ['Cats and dogs', 'Cats only', 'Dogs only', 'Not allowed'],
          },
          option7: {
            name: 'Parking',
            values: [
              'Attached garage',
              'Carport',
              'Detached garage',
              'Off-street parking',
              'Street parking',
              'Valet parking',
              'No parking',
            ],
          },
          option8: {
            name: 'EV charging',
            values: ['Yes', 'No'],
          },
        },
      },
      {
        id: '18-2',
        name: 'Commercial Real Estate for Rent',
        img: {
          className: 'subcategory_img',
          src: 'icons/sub/office.svg',
          alt: 'Commercial Real Estate for Rent',
        },
        productsLink: 'products/commercial_real_estate_rent',
        options: {
          option1: {
            name: 'Type of commercial property',
            values: [
              'Office Space',
              'Retail Space',
              'Warehouse',
              'Industrial Space',
              'Coworking Space',
              'Other',
            ],
          },
          option2: {
            name: 'Rent period',
            values: ['Daily', 'Weekly', 'Monthly', 'Long term'],
          },
          option3: {
            name: 'Furnished?',
            values: ['Yes', 'No'],
          },
        },
      },
      {
        id: '18-3',
        name: 'Land for Lease',
        img: {
          className: 'subcategory_img',
          src: 'icons/sub/plot.svg',
          alt: 'Land for Lease',
        },
        productsLink: 'products/land_parcels_rent',
        options: {
          option1: {
            name: 'Purpose',
            values: ['Agriculture', 'Construction', 'Business', 'Other'],
          },
          option2: {
            name: 'Size in acres',
            values: ['1-10', '11-30', '31-40', '40 and more'],
          },
          option3: {
            name: 'Rent period',
            values: ['Daily', 'Weekly', 'Monthly', 'Long term'],
          },
          option4: {
            name: 'Water supply',
            values: ['Available', 'No'],
          },
          option5: {
            name: 'Electricity',
            values: ['Available', 'No'],
          },
          option6: {
            name: 'Safety',
            values: ['Video surveillance', 'Security', 'Lighting'],
          },
        },
      },
      {
        id: '18-4',
        name: 'Parking Spaces for Rent',
        img: {
          className: 'subcategory_img',
          src: 'icons/sub/car-parking.svg',
          alt: 'Parking Spaces for Rent',
        },
        productsLink: 'products/parking_rent',
        options: {
          option1: {
            name: 'Type',
            values: ['Indoor', 'Outdoor'],
          },
          option2: {
            name: 'Safety',
            values: ['Video surveillance', 'Security', 'Lighting'],
          },
          option3: {
            name: 'Rent period',
            values: ['Daily', 'Weekly', 'Monthly', 'Long term'],
          },
          option4: {
            name: 'EV charging',
            values: ['Yes', 'No'],
          },
        },
      },
      {
        id: '18-5',
        name: 'Hotels for Rent',
        img: {
          className: 'subcategory_img',
          src: 'icons/sub/special_offers.png',
          alt: 'Hotels for Rent',
        },
        productsLink: 'products/hotels_rent',
        options: {
          option1: {
            name: 'Type',
            values: ['Hotel', 'Hostel', 'Resort complex', 'Motel', 'Other'],
          },
          option2: {
            name: 'Swimming pool',
            values: ['Available', 'No'],
          },
          option3: {
            name: 'Rent period',
            values: ['Daily', 'Weekly', 'Monthly', 'Long term'],
          },
          option4: {
            name: 'EV charging',
            values: ['Yes', 'No'],
          },
        },
      },
      {
        id: '18-6',
        name: 'Residential Real Estate for Sale',
        img: {
          className: 'subcategory_img',
          src: 'icons/sub/residential_real_estate.png',
          alt: 'Residential Real Estate for Sale',
        },
        productsLink: 'products/residential_real_estate_sale',
        options: {
          option1: {
            name: 'Type of residential property',
            values: [
              'Cottage',
              'Condo',
              'Flat',
              'Loft',
              'Apartment',
              'Townhouse',
              'Duplex',
              'Triplex',
              'Mobile Home',
              'Other',
            ],
          },
          option2: {
            name: 'Furnished?',
            values: ['Yes', 'No'],
          },
          option3: {
            name: 'Bedrooms qty',
            values: ['0', '1', '2', '3', '4', '5', '6 and more'],
          },
          option4: {
            name: 'Bathrooms qty',
            values: ['0', '1', '2', '3', '4', '5 and more'],
          },
          option5: {
            name: 'Floor',
            values: ['0-1', '2-3', '4-6', '7 and more'],
          },
          option7: {
            name: 'Parking',
            values: [
              'Attached garage',
              'Carport',
              'Detached garage',
              'Off-street parking',
              'Street parking',
              'Valet parking',
              'No parking',
            ],
          },
          option8: {
            name: 'EV charging',
            values: ['Yes', 'No'],
          },
        },
      },
      {
        id: '18-7',
        name: 'Commercial Real Estate for Sale',
        img: {
          className: 'subcategory_img',
          src: 'icons/sub/commercial_real_estate.png',
          alt: 'Commercial Real Estate for Sale',
        },
        productsLink: 'products/commercial_real_estate_sale',
        options: {
          option1: {
            name: 'Type of commercial property',
            values: [
              'Office Space',
              'Retail Space',
              'Warehouse',
              'Industrial Space',
              'Coworking Space',
              'Other',
            ],
          },
          option2: {
            name: 'Furnished?',
            values: ['Yes', 'No'],
          },
        },
      },
      {
        id: '18-8',
        name: 'Land for Sale',
        img: {
          className: 'subcategory_img',
          src: 'icons/sub/land.svg',
          alt: 'Land for Sale',
        },
        productsLink: 'products/land_parcels_sale',
        options: {
          option1: {
            name: 'Purpose',
            values: ['Agriculture', 'Construction', 'Business', 'Other'],
          },
          option2: {
            name: 'Size in acres',
            values: ['1-10', '11-30', '31-40', '40 and more'],
          },
          option3: {
            name: 'Water supply',
            values: ['Available', 'No'],
          },
          option4: {
            name: 'Electricity',
            values: ['Available', 'No'],
          },
          option5: {
            name: 'Safety',
            values: ['Video surveillance', 'Security', 'Lighting'],
          },
        },
      },
      {
        id: '18-9',
        name: 'Parking Spaces for Sale',
        img: {
          className: 'subcategory_img',
          src: 'icons/sub/house-garage.svg',
          alt: 'Parking Spaces for Sale',
        },
        productsLink: 'products/parking_sale',
        options: {
          option1: {
            name: 'Type',
            values: ['Indoor', 'Outdoor'],
          },
          option2: {
            name: 'Safety',
            values: ['Video surveillance', 'Security', 'Lighting'],
          },
          option3: {
            name: 'EV charging',
            values: ['Yes', 'No'],
          },
        },
      },
    ],
  },
];

export default categoriesData;
